

import Swal from "sweetalert2";
import { dataAxureFetch } from "../helpers/fetch";
import { types } from "../types/types";

/**
 * Function to set information for the Redux
 * @param {string} star -Date start
 * @param {string} end -End start
 * @param {string} point -Name of the point
 * @param {object} data -Object of request information
 */
const date = (star,end,point,data) =>{
    return {
        type: types.printSetDate,
        payload:{
            startDate: star,
            endDate: end,
            namePoint: point,
            dataInformation: data,
        }
    }
}

/**
 * Get information data for the report
 * @param {string} star -Date start
 * @param {string} end  -End start
 * @param {string} point -Name of the point
 * @param {number} uid -Number ID of the client
 */
export const getInformationdate = (star,end,point,uid) =>{
    console.log(star)
    console.log(end)
    console.log(uid)
    return async (dispatch)=>{
        
        const body = await (dataAxureFetch(
            {
                fecI: star,
                fecF: end,
                punto: point,
                idCliente: uid
            },
            'POST'
        ));

        if (body===null) {
            return Swal.fire('','No se genera reporte para la fecha seleccionada','info')
        }else{
            dispatch(date(star,end,point,body))
            return Swal.fire('Correcto','Reporte generado','success')
        }

    }
}